import { ImageService } from './image-join-service';

type DocumentWithOptionalBody = {
  document_name?: string;
  document_type?: string;
  id_number?: string;
  document_body?: string;
  initial?: boolean;
};

const joinDocs = async (
  id: string,
  documents: DocumentWithOptionalBody[],
): Promise<DocumentWithOptionalBody> => {
  const firstDoc = documents[0];
  const secondDoc = documents[1];

  if (!firstDoc.document_body || !secondDoc.document_body) {
    throw new Error('Upload docs Revamp: No body in images');
  }

  const merged = await ImageService.joinImages(
    id,
    firstDoc.document_body,
    secondDoc.document_body,
    new AbortController(),
  );

  return {
    document_name: `${id}.png`,
    document_type: firstDoc.document_type,
    document_body: merged,
    id_number: id,
  };
};

async function joinDocsById(
  documents: DocumentWithOptionalBody[],
): Promise<DocumentWithOptionalBody[]> {
  const noIdKey = 'no-id';
  const docMap = new Map<string, DocumentWithOptionalBody[]>();

  documents.forEach((doc) => {
    if (!doc.id_number) {
      docMap.set(noIdKey, [...(docMap.get(noIdKey) || []), doc]);
      return;
    }

    if (docMap.get(doc.id_number)) {
      docMap.set(doc.id_number, [...(docMap.get(doc.id_number) || []), doc]);
    } else {
      docMap.set(doc.id_number, [doc]);
    }
  });

  const result: Promise<DocumentWithOptionalBody>[] = [];

  docMap.forEach((docArray, key) => {
    if (docArray.length === 2 && key !== noIdKey) {
      result.push(joinDocs(key, docArray));
      return;
    }

    result.push(...docArray.map((doc) => Promise.resolve(doc)));
  }, []);

  return await Promise.all(result);
}

export const LegacyImageService = { joinDocsById };
